import React from "react";

/* eslint-disable react/prop-types */

export const ZoomContext = React.createContext({
  zoomMinimum: null,
  zoomMaximum: null,
  zoom: 1,
  onZoomChange: null
});

export function withZoomContext(Component) {
  const ZoomedComponent = props => {
    const { forwardedRef, ...rest } = props;
    return (
      <ZoomContext.Consumer>
        {zoomContext => {
          return <Component ref={forwardedRef} {...rest} {...zoomContext} />;
        }}
      </ZoomContext.Consumer>
    );
  };

  return React.forwardRef((props, ref) => {
    return <ZoomedComponent {...props} forwardedRef={ref} />;
  });
}
